<div class="t-popup popup-patientDetails">
  <div class="t-popup-close"></div>

  <div class="t-popup-frame" style="width: 65em; max-width: fit-content">
    <div class="t-popup-body" [formGroup]="concentForm">
      <button
        class="t-btn-popup-close"
        matTooltip="Close Popup"
        aria-label="close popup"
        (click)="close(false)"
      ></button>
      <div class="m-box w100" style="direction: rtl; font-size: 20px">
        <h2>הסכמה מדעת</h2>
        <div class="r-concent l-end">
          <div style="border: 1px solid black" *ngIf="waitingForSignatures">
            ממתין לקבלת טופס חתום
          </div>
          <div style="border: 1px solid black" *ngIf="errorInSignature">
            חסרות חתימות יש לשלוח את הטופס שוב
          </div>
          <span
            class="l-header-panel header-menu-link icon-link concent-link"
            (click)="
              lockedConsent ||
              (concentForm.get('ExamType').value !== 'NT' && !concentForm.get('weekNum').value) ||
              !concentForm.get('docSign').value
                ? ''
                : handleSaveAndShowLink()
            "
            style="margin-left: 0.5em; margin-right: 1em; cursor: pointer"
            [ngStyle]="lockedConsent ? {} : { cursor: 'pointer' }"
            aria-label="Link"
            [matTooltip]="linkTooltipMsg()"
          >
          </span>
          <span
            (click)="
              concentForm.get('ExamType').value !== 'NT' && !concentForm.get('weekNum').value
                ? ''
                : printConsent()
            "
            class="header-menu-link icon-print"
            aria-label="Print"
            matTooltip="Print"
            style="
              margin-left: 0.5em;
              margin-right: 1em;
              cursor: pointer;
              filter: invert(39%) sepia(8%) saturate(4116%) hue-rotate(143deg) brightness(60%)
                contrast(78%);
            "
          ></span>
        </div>

        <span>
          <h2 *ngIf="concentForm.get('ExamType').value === 'NT'">
            בדיקה לשקיפות עורפית - - הצהרת הנבדקת
          </h2>
          <h2 *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
            בדיקת התפתחות העובר בשליש השלישי - - הצהרת הנבדקת
          </h2>
          <h2
            *ngIf="
              concentForm.get('ExamType').value !== 'NT' &&
              concentForm.get('ExamType').value !== 'Third Scan'
            "
          >
            בדיקת אולטרה סאונד עוברי - - הצהרת הנבדקת
          </h2>
        </span>
        <div style="direction: rtl; margin-bottom: 1em">
          <ng-container
            *ngIf="
              concentForm.get('ExamType').value &&
              concentForm.get('ExamType').value !== 'NT' &&
              concentForm.get('ExamType').value !== 'Third Scan'
            "
          >
            <span>
              {{
                (concentForm.get('ExamType').value && concentForm.get('ExamType').value !== 'NT'
                  ? 'exam.type.OBS.' + concentForm.get('ExamType').value
                  : ''
                ) | translate
              }}
              -- היא בדיקת אולטרסאונד המתבצעת ע"י רופא העומד בדרישות משרד הבריאות לביצוע הבדיקה.
              מטרת הבדיקה הינה לבדוק את מבנה איברי הגוף של העובר בהתאם לפירוט שנקבע על ידי האיגוד
              הישראלי למיילדות וגינקולוגיה ומפורט בדו"ח הבדיקה. הבדיקה נעשית באמצעות מכשיר
              אולטרסאונד בגלי על קול. הבדיקה אינה מסוכנת לאם או לעובר. הבדיקה נעשית בגישה בטנית
              ובמידת הצורך גם בגישה לדנית.
            </span>
          </ng-container>
          <span *ngIf="concentForm.get('ExamType').value === 'NT'">
            {{ 'exam.type.OBS.' + concentForm.get('ExamType').value | translate }} -- בדיקת שקיפות
            עורפית הינה בדיקת אולטרסאונד המבוצעת באשה הרה לצורך הערכת הסיכון לתסמונת דאון (Syndrome
            Down )ולליקויים נוספים. על פי הנחיות משרד הבריאות שקיפות עורפית הינה בדיקת הסינון
            המומלצת לאיתור תסמונת דאון בהריונות יחיד ובהריונות מרובי עוברים כאחד. הבדיקה מבוצעת בין
            שבוע 11 ל- 13+6 (תואם גודל עובר של 45-84 מ"מ), בגישה בטנית או בגישה לדנית, בהתאם להחלטת
            הרופא המבצע. בבדיקה נמדד עובי הנוזל התת עורי בעורף העובר. שילוב בין ממצאי הבדיקה וסיכון
            הרקע הנגזר מגיל האם, מאפשר הערכת סיכון סטטיסטי לתסמונת דאון. בהריון עם עובר יחיד מומלץ
            לשלב את התוצאה עם סמנים ביוכימיים מדם האם. הובהר לי שבמידה ותמצא דרגת סיכון גבוהה
            לתסמונת דאון, אופנה ליעוץ גנטי לקביעת המלצות להמשך בירור. הבדיקה אינה יכולה לשלול תסמונת
            דאון או הפרעות כרומוזומליות אחרות באופן מוחלט. ניתן להגיע לאבחנה סופית של תסמונת דאון או
            הפרעות כרומוזומליות נוספות, רק באמצעות בדיקות פולשניות (דיקור מי שפיר או סיסי שליה). כן
            הובהר לי כי במקרה של שקיפות עורפית מעל 3 מ"מ, קיים סיכון מוגבר למומים נוספים, ולפיכך
            מימצא זה לכשעצמו מצדיק הפנייה ליעוץ גנטי, ולאקו לב עובר. הובהר לי שתוצאה המצביעה על רמת
            סיכון נמוכה אינה מבטלת המלצה לבדיקה פולשנית מסיבות אחרות. בכל מקרה יועץ גנטי הינו הגורם
            המוסמך ליעוץ, המלצה ולקביעת זכאות האישה לבדיקה פולשנית. עוד הובהר לי כי הבדיקה אינה
            מחליפה בדיקות אחרות, כמו בדיקות סקר גנטיות או חלבון עוברי כבדיקת סקירה למומים פתוחים
            במערכת העצבים. בדיקת שקיפות עורפית אינה סקירת מערכות. יש לפנות עם תוצאות הבדיקה לרופא
            המטפל
          </span>
          <span *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
            {{ 'exam.type.OBS.' + concentForm.get('ExamType').value | translate }} -- בדיקת התפתחות
            העובר בשליש השלישי הינה הערכת התפתחות העובר הינה בדיקת אולטרסאונד המתבצעת ע"י רופא העומד
            בדרישות משרד הבריאות לביצוע הבדיקה. מטרת הבדיקה הינה לבדוק את התפתחות איברי הגוף של
            העובר, בהתאם לפירוט שנקבע על ידי האיגוד הישראלי למיילדות וגינקולוגיה ומפורט בדו''ח
            הבדיקה. הבדיקה נעשית באמצעות מכשיר אולטרה סאונד המשתמש בגלי על קול. הבדיקה אינה מסוכנת
            לאם או לעובר. הבדיקה נעשית בגישה בטנית ובמידת הצורך גם בגישה לדנית.
          </span>
        </div>
        <div>
          <span><strong>שם הנבדקת</strong></span>
        </div>
        <div style="display: flex; margin-bottom: 2em">
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="Last"
              class="l-textarea t-field--limitRad w100 h100"
              style="margin-left: 5px; border-radius: inherit"
              placeholder="שם משפחה"
            />
          </div>
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="First"
              class="l-textarea t-field--limitRad w100 h100"
              style="margin-left: 5px; border-radius: inherit"
              placeholder="שם פרטי"
            />
          </div>
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="ID"
              class="l-textarea t-field--limitRad w100 h100"
              style="margin-left: 5px; border-radius: inherit"
              placeholder="ת.ז"
            />
          </div>
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="Phone"
              class="l-textarea t-field--limitRad w100 h100"
              style="margin-left: 5px; border-radius: inherit"
              placeholder="טלפון"
            />
          </div>
        </div>
        <div>
          <span>
            <strong style="margin-left: 1em"
              >אני מצהירה ומאשרת בזאת שקיבלתי הסבר מפורט ובעל פה מ</strong
            >
            <input
              formControlName="refferalDoc"
              class="l-textarea t-field--limitRad h100"
              style="margin-left: 5px; border-radius: 0.75em"
              placeholder="שם הרופא"
          /></span>
        </div>
        <div style="display: grid">
          <ng-container *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
            <span>
              <strong>
                על
                {{
                  (concentForm.get('ExamType').value
                    ? 'exam.type.OBS.' + concentForm.get('ExamType').value
                    : ''
                  ) | translate
                }}
                (להלן "הפעולה העיקרית"), הבנתי אותה וניתנה לי האפשרות לשאול שאלות ולדון על הפעולה,
                החלופות הטיפוליות, הסיכונים והתועלת.
              </strong>
            </span>
          </ng-container>
          <ng-container *ngIf="concentForm.get('ExamType').value !== 'Third Scan'">
            <span>
              <strong>
                על הצורך בביצוע הפעולה העיקרית בדיקת אולטרה סאונד עוברי --
                {{
                  (concentForm.get('ExamType').value
                    ? 'exam.type.OBS.' + concentForm.get('ExamType').value
                    : ''
                  ) | translate
                }}
              </strong>
            </span>
          </ng-container>
          <input
            formControlName="CreationTime"
            type="datetime-local"
            formtarget="yyyy-MM-ddThh:mm"
            class="w50 l-textarea t-field--limitRad h100"
            style="margin-left: 5px; border-radius: 0.75em; place-self: center"
            placeholder="טלפון"
          />
        </div>
        <div style="display: grid; place-self: center">
          <span>חתימת הנבדקת\אפוטרופוס</span>
          <canvas
            id="canvas"
            #canvas
            [style.border]="'1px solid black'"
            [ngClass]="type == 'canvas' ? 'can-shadow' : ''"
            width="500"
            height="200"
            [ngClass]="{ 'disabled-canvas': lockedConsent }"
            (click)="setCanvas('canvas')"
          ></canvas>
          <button
            [disabled]="lockedConsent"
            style="position: relative; top: -2em; width: fit-content"
            (click)="clear('patSign')"
          >
            <ng-container>
              <img
                src="../../assets/icons/login/reset.png"
                style="height: 1.5em; width: 1.5em"
                matTooltip="Clear"
              />
            </ng-container>
          </button>
        </div>
        <hr class="r-concent" />
        <ng-container
          *ngIf="
            concentForm.get('ExamType').value !== 'NT' &&
            concentForm.get('ExamType').value !== 'Third Scan'
          "
        >
          <div class="r-concent">
            1.הובהר לי כי בדיקת האולטרה סאונד העוברי הינה (סמן את הבדיקה שתבוצע):
            <div style="width: 100%; display: flex; align-items: center; gap: 1em">
              <select formControlName="ExamType" class="t-field t-select">
                <option *ngFor="let exam of OBEXAMS" [value]="exam">
                  {{ 'exam.type.OBS.' + exam | translate }}
                </option>
              </select>
              <span [ngClass]="{ 'missing-label': isWeeksMissingNonNT, 'label-transition': true }">
                בשבוע:
              </span>
              <input
                [ngClass]="{ 'missing-field': isWeeksMissingNonNT, 'border-transition': true }"
                formControlName="weekNum"
                class="w50 l-textarea t-field--limitRad h100"
                style="margin-left: 5px; border-radius: 0.75em; place-self: center"
                placeholder="שדה חובה- בטרם שליחת הטופס או הדפסה"
              />
            </div>
          </div>
          <div class="r-concent">
            2. הבדיקה נעשית ביוזמת
            <div
              class="l-flex-c l-flex-w indicative-fieldset h100"
              style="justify-content: space-evenly"
            >
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="preformed"
                  value="women"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> הנבדקת </span>
              </label>
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="preformed"
                  value="doctor"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> על פי הפנית רופא </span>
              </label>
            </div>
            <div style="display: grid">
              <span *ngIf="concentForm.get('preformed').value == 'doctor'">סיבת הפניה</span>
              <textarea
                *ngIf="concentForm.get('preformed').value == 'doctor'"
                class="scroller fulltext"
                formControlName="docReason"
              ></textarea>
              <span>בהעדר פרוט הסיבה להפניה, ההתייחסות בבדיקה הינה להריון בסיכון נמוך.</span>
            </div>
          </div>
          <div class="r-concent">3. הנתונים שיבדקו הם אלה שיודגמו ויסומנו בטופס הבדיקה.</div>
          <div class="r-concent">
            4. ידוע לי שבדיקת האולטרה סאונד הינה מוגבלת ואינה יכולה או מתיימרת לאתר את כל המומים /
            הפגמים האפשריים בעובר, בכל מקרה ובכל הריון, גם לא את כל המומים באברים שנבדקו.
          </div>
          <div class="r-concent">
            5. ידוע לי שישנם מומים / ליקויים אשר לא ניתנים לאבחון מוחלט בבדיקת אולטרה סאונד (כגון:
            תסמונת דאון, מחלות גנטיות, מחלות זיהומיות ועוד).
          </div>
          <div class="r-concent">
            6. ידוע לי שמידת הדיוק ויכולת האיתור של מומים או פגמים תלויים באופי הממצא וגודלו (כגון:
            פגמים באצבעות), וכן בגיל ההיריון, מיקום העובר, תנוחתו, תנועותיו ומידת העבירות של גלי
            הקול (דופן הבטן).
          </div>
          <div class="r-concent">
            7. ידוע לי שתוצאות הבדיקה משקפות, במגבלות הקיימות, את המצב בזמן הבדיקה וכי ישנם מומים
            העלולים להתפתח או להתגלות רק בהמשך ההיריון (כגון: הפרעות גדילה, סוגי גמדות, מומי לב, מוח
            ועוד).
          </div>
          <div class="r-concent">
            8. ידוע לי כי בבדיקה בה נצפה ממצא חריג יהיה צורך, ע"פ החלטת הרופא המטפל, לבצע בדיקות
            נוספות (כגון: אקו לב-עובר, MRI, יעוץ גנטי, דיקור מי שפיר ויעוץ רופא מומחה בתחום ועוד).
          </div>
          <div class="r-concent">
            9. ידוע לי שסקירת מערכות מוקדמת המבוצעת בשבועות 13-17, איננה מחליפה את הסקירה המאוחרת
            אותה מומלץ לבצע בשבועות 19-25, מכיוון שחלק מהמומים שניתן לאבחן בסקירה המאוחרת, אינם
            מתבטאים בסקירה המוקדמת.
          </div>
          <div class="r-concent">
            10. ניתן יהיה לבצע בדיקות נוספות גם בהעדר ממצאים, על פי רצוני ועל חשבוני.
          </div>
          <div class="r-concent">
            <strong>
              הובהר לי כי בכל מקרה עלי להציג את תוצאות הבדיקה בפני רופא הנשים המטפל. לתשומת לבך:
              בדיקות במסגרות ציבוריות מבוצעות בהתאם ל"סל שירותי הבריאות". לאחר שכל האמור לעיל הובן
              על ידי, הנני מסכימה לביצוע הבדיקה במגבלות האמורות לעיל.
            </strong>
          </div>
        </ng-container>
        <ng-container *ngIf="concentForm.get('ExamType').value === 'Third Scan'">
          <div class="r-concent">
            1.הובהר לי כי הבדיקת הינה (סמן את הבדיקה שתבוצע):
            <div style="width: 100%; display: flex; align-items: center; gap: 1em">
              <select formControlName="ExamType" class="t-field t-select">
                <option *ngFor="let exam of OBEXAMS" [value]="exam">
                  {{ 'exam.type.OBS.' + exam | translate }}
                </option>
              </select>
              <span [ngClass]="{ 'missing-label': isWeeksMissing, 'label-transition': true }">
                בשבוע:
              </span>
              <input
                [ngClass]="{ 'missing-field': isWeeksMissing, 'border-transition': true }"
                formControlName="weekNum"
                class="w50 l-textarea t-field--limitRad h100"
                style="margin-left: 5px; border-radius: 0.75em; place-self: center"
                placeholder="שדה חובה- בטרם שליחת הטופס או הדפסה"
              />
            </div>
          </div>
          <div class="r-concent">
            2. הבדיקה נעשית ביוזמת
            <div
              class="l-flex-c l-flex-w indicative-fieldset h100"
              style="justify-content: space-evenly"
            >
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="preformed"
                  value="women"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> הנבדקת </span>
              </label>
              <label class="t-label-top">
                <input
                  type="radio"
                  formControlName="preformed"
                  value="doctor"
                  class="custom-check -sq"
                />
                <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
                <span> על פי הפנית רופא </span>
              </label>
            </div>
            <div style="display: grid">
              <span *ngIf="concentForm.get('preformed').value == 'doctor'">סיבת הפניה</span>
              <textarea
                *ngIf="concentForm.get('preformed').value == 'doctor'"
                class="scroller fulltext"
                formControlName="docReason"
              ></textarea>
              <span>בהעדר פרוט הסיבה להפניה, ההתייחסות בבדיקה הינה להריון בסיכון נמוך.</span>
            </div>
          </div>
          <div class="r-concent">3. הנתונים שיבדקו הם אלה שיודגמו ויסומנו בטופס הבדיקה.</div>
          <div class="r-concent">
            4. ידוע לי שבדיקת האולטרה סאונד הינה מוגבלת ואינה יכולה או מתיימרת לאתר את כל המומים /
            הפגמים האפשריים בעובר, בכל מקרה ובכל היריון, גם לא את כל המומים באברים שנבדקו.
          </div>
          <div class="r-concent">
            5. ידוע לי שישנם מומים / ליקויים אשר לא ניתנים לאבחון מוחלט בבדיקת אולטרה סאונד (כגון:
            תסמונת דאון, מחלות גנטיות, מחלות זיהומיות ועוד).
          </div>
          <div class="r-concent">
            6. ידוע לי שמידת הדיוק ויכולת האיתור של מומים או פגמים תלויים באופי הממצא וגודלו (כגון:
            פגמים באצבעות), וכן בגיל ההיריון, מיקום העובר, תנוחתו, תנועותיו ומידת העבירות של גלי
            הקול (דופן הבטן).
          </div>
          <div class="r-concent">
            7. ידוע לי שתוצאות הבדיקה משקפות, במגבלות הקיימות, את המצב בזמן הבדיקה וכי ישנם מומים
            העלולים להתפתח או להתגלות רק בהמשך ההיריון.
          </div>
          <div class="r-concent">
            8. ידוע לי שבמצב של עודף משקל ( BMI 30 ומעלה) שיעור זיהוי המומים נמוך יותר.
          </div>
          <div class="r-concent">
            9. ידוע לי כי בבדיקה בה נצפה ממצא חריג יהיה צורך, ע"פ החלטת הרופא המטפל, לבצע בדיקות
            נוספות (כגון: אקו לב-עובר, MRI, יעוץ גנטי, דיקור מי שפיר ויעוץ רופא מומחה בתחום ועוד).
          </div>
          <div class="r-concent">
            10. ידוע לי שאין בדיקה זו מהווה סקירה מלאה וכי בדיקת אולטרה-סאונד בשליש השלישי מוגבלת
            מאד ביכולת דימות אברי העובר. מגבלות אלו מונעות אפשרות לסקירה נאותה ולהדגמה של כל האיברים
            האמורים להיבדק בסקירת המערכות הרגילה המבוצעת בשליש השני להריון.
          </div>
          <div class="r-concent">
            11. ניתן יהיה לבצע בדיקות נוספות גם בהעדר ממצאים, על פי רצוני ועל חשבוני.
          </div>
          <div class="r-concent">
            <strong>
              הובהר לי כי <span style="text-decoration: underline"> בכל מקרה</span>
              עלי להציג את תוצאות הבדיקה בפני רופא הנשים המטפל. לאחר שכל האמור לעיל הובן על ידי,
              הנני מסכימה לביצוע הבדיקה במגבלות האמורות לעיל.
            </strong>
          </div>
        </ng-container>

        <div class="r-concent">
          <strong>אני נותנת בזאת את הסכמתי לביצוע הפעולה העיקרית.</strong>
        </div>
        <div style="display: grid; margin-bottom: 1em">
          <input
            formControlName="CreationTime"
            type="datetime-local"
            formtarget="yyyy-MM-ddThh:mm"
            class="w50 l-textarea t-field--limitRad h100"
            style="margin-left: 5px; border-radius: 0.75em; place-self: center"
            placeholder="טלפון"
          />
        </div>
        <!-- <div *ngIf="concentForm.get('approved').value == 'paitent'" style="display: grid;place-self: center;"> -->
        <div
          [ngClass]="concentForm.get('approved').value == 'paitent' ? '' : 'hidden'"
          style="display: grid; place-self: center"
        >
          <span>חתימת הנבדקת\אפוטרופוס</span>
          <canvas
            id="canvasPat"
            #canvasPat
            [style.border]="'1px solid black'"
            [ngClass]="type == 'canvasPat' ? 'can-shadow' : ''"
            width="500"
            height="200"
            [ngClass]="{ 'disabled-canvas': lockedConsent }"
            (click)="setCanvas('canvasPat')"
          ></canvas>
          <button
            [disabled]="lockedConsent"
            style="position: relative; top: -2em; width: fit-content"
            (click)="clear('patSignApproved')"
          >
            <ng-container>
              <img
                src="../../assets/icons/login/reset.png"
                style="height: 1.5em; width: 1.5em"
                matTooltip="Clear"
              />
            </ng-container>
          </button>
        </div>
        <div class="r-concent">
          <span>אני מאשר כי הסברתי בעל פה</span>
          <div
            class="l-flex-c l-flex-w indicative-fieldset h100"
            style="justify-content: space-evenly"
          >
            <label class="t-label-top">
              <input
                type="radio"
                formControlName="approved"
                value="paitent"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
              <span> לנבדקת </span>
            </label>
            <label class="t-label-top">
              <input
                type="radio"
                formControlName="approved"
                value="appotropus"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
              <span> לאפוטרופוס </span>
            </label>
            <label class="t-label-top">
              <input
                type="checkbox"
                name="placenta_TEMP_name"
                class="custom-check -sq"
                formControlName="translated"
                [value]="1"
              />
              <i class="customInput-display"></i>
              <span> למתרגם של המטופלת </span>
            </label>
            <div *ngIf="concentForm.get('translated').value == 1">
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <!-- <span style="align-self: center;">טלפון</span> -->
                <input
                  formControlName="transName"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="שם המתרגם/ת"
                />
              </div>
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <!-- <span style="align-self: center;">טלפון</span> -->
                <input
                  formControlName="transRel"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="קשריו לנדבקת"
                />
              </div>
            </div>
          </div>
          <div>
            את כל האמור לעיל בפירוט הדרוש וכי הוא/היא חתם/ה על הסכמה בפני לאחר ששוכנעתי כי הבין/ה את
            הסבריי במלואם.
          </div>
          <div *ngIf="concentForm.get('approved').value == 'appotropus'">
            <div style="display: flex">
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <!-- <span style="align-self: center;">טלפון</span> -->
                <input
                  formControlName="appName"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="שם האפוטרופוס"
                />
              </div>
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <!-- <span style="align-self: center;">טלפון</span> -->
                <input
                  formControlName="appRel"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="קשריו לנבדקת"
                />
              </div>
            </div>
            <div style="display: grid; place-self: center">
              <span>חתימת אפוטרופוס</span>
              <canvas
                id="canvasApp"
                #canvasApp
                [style.border]="'1px solid black'"
                [ngClass]="type == 'canvasApp' ? 'can-shadow' : ''"
                width="500"
                height="200"
                [ngClass]="{ 'disabled-canvas': lockedConsent }"
                (click)="setCanvas('canvasApp')"
              ></canvas>
              <button
                [disabled]="lockedConsent"
                style="position: relative; top: -2em; width: fit-content"
                (click)="clear('appSign')"
              >
                <ng-container>
                  <img
                    src="../../assets/icons/login/reset.png"
                    style="height: 1.5em; width: 1.5em"
                    matTooltip="Clear"
                  />
                </ng-container>
              </button>
            </div>
          </div>
          <div style="display: flex; margin-top: 2em">
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 30%"
            >
              <!-- <span style="align-self: center;">שם משפחה</span> -->
              <input
                formControlName="refferalDoc"
                class="l-textarea t-field--limitRad w100 h100"
                style="margin-left: 5px; border-radius: inherit"
                placeholder="שם משפחה"
              />
            </div>
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 70%"
            >
              <!-- <span style="align-self: center;">שם פרטי</span> -->
              <input
                formControlName="CreationTime"
                class="l-textarea t-field--limitRad w100 h100"
                style="margin-left: 5px; border-radius: inherit"
                placeholder="שם פרטי"
              />
            </div>
          </div>
          <div style="display: grid; place-self: center">
            <span>חתימת הרופא</span>
            <canvas
              id="canvasDoc"
              #canvasDoc
              [style.border]="'1px solid black'"
              [ngClass]="type == 'canvasDoc' ? 'can-shadow' : ''"
              width="500"
              height="200"
              [ngClass]="{ 'disabled-canvas': lockedConsent }"
              (click)="setCanvas('canvasDoc')"
            ></canvas>
            <button
              [disabled]="lockedConsent"
              style="position: relative; top: -2em; width: fit-content"
              (click)="clear('docSign')"
            >
              <ng-container>
                <img
                  src="../../assets/icons/login/reset.png"
                  style="height: 1.5em; width: 1.5em"
                  matTooltip="Clear"
                />
              </ng-container>
            </button>
          </div>
        </div>
        <div *ngIf="!lockedConsent" class="r-concent btn-row" class="r-concent btn-row">
          <button (click)="closed.emit('1')" class="orange-btn">בטל</button>
          <button [disabled]="toggleSave()" (click)="close(true)" class="blue-btn">
            שמור טופס חתום
          </button>
        </div>
      </div>
      <app-send-link
        *ngIf="showlink"
        (closed)="closeSendLinks($event)"
        [exam]="null"
        [isForm]="true"
        [concent]="concentForm.value"
        (closeFromLinks)="closeFromLinks($event)"
      >
      </app-send-link>
    </div>
  </div>
</div>
